import { Route, Routes } from 'react-router-dom';

import Material from './material-page';
import Materials from './materials-page';

export default function MaterialsRouter() {
    return (
        <Routes>
            <Route
                path="/"
                element={<Materials />}
            />

            <Route
                path="/:id"
                element={<Material />}
            />
        </Routes>
    );
}